import * as React from "react";
import { Switcher } from "~/sharedComponents/buttons";
import { WithEditModeProps } from "~/sharedHOC/withEditMode/withEditMode";
import { SwitcherWithHint } from "../buttons/Switcher";
import * as styles from "./InlineEditSwitcherAdapter.less";

type Props = Omit<React.ComponentProps<typeof SwitcherWithHint>, "value" | "isDisabled" | "hint"> &
    Pick<WithEditModeProps, "value" | "disabled" | "description">;

export const InlineEditSwitcherAdapter: React.FC<Props> = props => {
    const { value, onChangeAction, label, disabled, description } = props;

    const Component = description ? SwitcherWithHint : Switcher;

    return (
        <Component
            className={styles.switcher_wrapper}
            label={label}
            labelAfterSwitcher={true}
            isOn={value}
            onChangeAction={onChangeAction}
            isDisabled={disabled}
            hint={description}
        />
    );
};
